import { apiService } from '../APIService';

const namespace = '/client-questions';

export default {
  getAll(params) {
    return apiService.get(`${namespace}`, params);
  },

  get(id, params) {
    return apiService.get(`${namespace}/${id}`, params);
  },

  update(id, params) {
    return apiService.put(`${namespace}/${id}`, params);
  },
  post(params) {
    return apiService.post(`${namespace}/`, params);
  },
  monitoring(params) {
    return apiService.get(`${namespace}/monitoring`, params);
  },

  /**
  * Ответить на заявки
  * @param {
  *   client_question_ids: Number[]
  *   text: String,
  *   images?: String[]
  *   documents?: String[]
  *  } params
 */
  answer(params) {
    return apiService.post(`${namespace}/answer`, params);
  },

  /**
   * Закрыть заявки
   * @param {
   *   client_question_ids: Number[]
   *  } params
  */
  close(params) {
    return apiService.post(`${namespace}/close`, params);
  },

  destroy(params) {
    /**
     * Удалить заявки
     * @param {
    *   client_question_ids: Number[]
    *  } params
     */
    return apiService.post(`${namespace}/destroy`, params);
  },
  updateStatus(id, status) {
    return apiService.post(`${namespace}/${id}/update-status`, { status });
  },
  take(id) {
    return apiService.post(`${namespace}/${id}/take`);
  },

  AnalyzeText(params) {
    return apiService.post('/hints/analyze-text', params);
  },
};
